// extracted by mini-css-extract-plugin
export default {"mapBox":"Map_mapBox__pF4qh","mapLink":"Map_mapLink__JU7il","mapAddr":"Map_mapAddr__xSFwx","mapTravelTime":"Map_mapTravelTime__bARl7"};